export const environment = {
  production: true,
  apiURL: 'https://trinity-staging.int.overlayer.ai/',
  googleTagManagerID: '',
  heapID: '',
  smartlookID: '',
  crispID: '',
  mrSatanURL: 'https://mrsatan-staging.int.overlayer.ai/',
  settingsURL: 'https://admin.staging.overlayer.ai/settings/installation-settings',
};
